<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
// FORK_PATCH_BEGIN: channel-hosting-status-light
import {
  hostingConnectionOf,
  hostingToneDotClass,
  hostingStatusTooltipKey,
} from 'dashboard/helper/channelHostingStatus';
// FORK_PATCH_END: channel-hosting-status-light
// FORK_PATCH_BEGIN: REQ-20260910-02 — Messenger auth light
import {
  messengerAuthDotClass,
  messengerAuthTooltipKey,
} from 'custom/dashboard/helper/messengerAuthStatus';
// FORK_PATCH_END: REQ-20260910-02

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/no-unused-properties
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

// FORK_PATCH_BEGIN: channel-hosting-status-light
const hostingConnection = computed(() => hostingConnectionOf(props.inbox));

const hostingDotClass = computed(() => {
  if (!hostingConnection.value) return null;
  return hostingToneDotClass(hostingConnection.value.tone);
});

const hostingTooltip = computed(() => {
  const key = hostingStatusTooltipKey(hostingConnection.value);
  return key ? t(key) : '';
});
// FORK_PATCH_END: channel-hosting-status-light

// FORK_PATCH_BEGIN: REQ-20260910-02 — Messenger auth light
const messengerDotClass = computed(() => messengerAuthDotClass(props.inbox));
const messengerTooltip = computed(() => {
  const key = messengerAuthTooltipKey(props.inbox);
  return key ? t(key) : '';
});
// FORK_PATCH_END: REQ-20260910-02
</script>

<template>
  <span class="size-4 grid place-content-center rounded-full relative">
    <ChannelIcon :inbox="inbox" class="size-4" />
    <!-- FORK_PATCH_BEGIN: channel-hosting-status-light -->
    <span
      v-if="hostingDotClass"
      v-tooltip.top-end="hostingTooltip"
      class="absolute -right-0.5 -bottom-0.5 size-2 rounded-full ring-2 ring-n-solid-2"
      :class="hostingDotClass"
    />
    <!-- FORK_PATCH_END: channel-hosting-status-light -->
    <!-- FORK_PATCH_BEGIN: REQ-20260910-02 — Messenger auth light -->
    <span
      v-if="!hostingDotClass && messengerDotClass"
      v-tooltip.top-end="messengerTooltip"
      class="absolute -right-0.5 -bottom-0.5 size-2 rounded-full ring-2 ring-n-solid-2"
      :class="messengerDotClass"
    />
    <!-- FORK_PATCH_END: REQ-20260910-02 -->
  </span>
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
